import { Context } from "../context";
import { PoserClock } from "./clock";

/**
 * Wrapper around instrumentation calls and dynamic responses to issues found
 * whilst monitoring (i.e. identifying when we're running at the wrong perf
 * level).
 */
export class PoserMonitor {
  issues = {
    workerSpeed: false,
    graphicsFps: false,
  };

  // TODO: reintroduce dynamic gpuLevel adjustments
  static perfMismatchMax = 3; // minutes
  private perfMismatch = { cnt: 0, triggered: false };

  private monitorFpsInterval = { id: -1, interval: 60000 };

  static bufferingCntMax = 3;
  private buffering = false;
  private bufferingCnt = 0;

  constructor(context: Context) {
    this.monitorFpsInterval.id = window.setInterval(() => {
      if (!context.state.focus.inFocus) return;

      const fps = context.clock.avgFps;
      DataDogWrapper.addAction("fieldvisionMonitor", {
        fps,
        relativeTime: context.clock.relative,
        gpuLevel: context.options.gpuLevel,
        issues: this.issues,
      });
    }, this.monitorFpsInterval.interval);
  }

  update(clock: PoserClock) {
    if (!this.buffering && clock.atBufferLimit()) {
      this.buffering = true;
      if (
        ++this.bufferingCnt >= PoserMonitor.bufferingCntMax &&
        !this.issues.workerSpeed
      ) {
        console.warn(
          "detecting worker message bottleneck - reducing tracking data fps"
        );
        this.issues.workerSpeed = true;
      }
    } else if (this.buffering && !clock.atBufferLimit()) {
      this.buffering = false;
    }
  }

  teardown() {
    window.clearInterval(this.monitorFpsInterval.id);
  }
}

class DataDogWrapper {
  static addAction(label: string, value: any) {
    //@ts-ignore
    if (window.DD_RUM) {
      //@ts-ignore
      window.DD_RUM.addAction(label, value);
    }
  }
}
